var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"remaining-time",class:{'out-header': !_vm.inHeader}},[_vm._v(" "+_vm._s(_vm.remainingTime)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }